import style from './CompanyObject.module.css';
import { Helmet } from 'react-helmet';

const OBJECT_SMALL = new URL(
  '../../../../images/OBJECTS_SMALL.png',
  import.meta.url,
).href;
const OBJECT_MEDIUM = new URL(
  '../../../../images/OBJECTS_MEDIUM.png',
  import.meta.url,
).href;
const OBJECT_LARGE = new URL('../../../../images/OBJECTS.png', import.meta.url)
  .href;

const CompanyObject = () => {
  return (
    <>
      <div className={style.companyObject}>
        <img
          src={OBJECT_LARGE}
          srcSet={`
            ${OBJECT_SMALL} 280w,
            ${OBJECT_MEDIUM} 316w,
            ${OBJECT_LARGE} 469w
          `}
          sizes="(max-width: 400px) 280px, 
                 (max-width: 768px) 316px, 
                 469px"
          alt="Artemida Studio - custom website development"
          width="469" // ✅ Чіткий розмір для уникнення CLS
          height="396"
          loading="eager" // ✅ Змінюємо на eager для LCP-елемента
          decoding="async"
          className={style.companyImage}
        />
      </div>
    </>
  );
};

export default CompanyObject;
